import { useNavigate, useParams } from "react-router-dom";
import DisputeDetailModal from "../../components/wallet/DisputeDetailModal";

/**
 * Standalone, shareable Dispute Details page (`/disputes/:disputeId`).
 *
 * Reuses the same DisputeDetailModal as the dashboard. The route sits behind RequireAuth, so
 * an inactive session is bounced to /login with the deep link saved in `postLoginRedirect`;
 * after login the user lands back here. Closing the modal returns to the dashboard.
 */
const DisputeDetailsPage = () => {
  const { disputeId } = useParams();
  const navigate = useNavigate();

  const goToDashboard = () => navigate("/", { replace: true });

  // No onChanged handler: after an appeal the modal refetches its own detail, so the user
  // stays on this page and sees the updated status.
  return (
    <DisputeDetailModal
      isOpen={Boolean(disputeId)}
      disputeId={disputeId}
      onClose={goToDashboard}
    />
  );
};

export default DisputeDetailsPage;
